module.exports = __webpack_public_path__ + "static/media/INSTRUCTIONS_FOR_ENTERING_C_SR_Contest_1_23_23.9d6c88f6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/2024/INSTRUCTIONS_FOR_ENTERING_C_SR_Contest_1_23_23.pdf
// module id = 215
// module chunks = 0